import { render, staticRenderFns } from "./ListOfPerspectives.vue?vue&type=template&id=aedddca8&scoped=true"
import script from "./ListOfPerspectives.vue?vue&type=script&lang=js"
export * from "./ListOfPerspectives.vue?vue&type=script&lang=js"
import style0 from "./ListOfPerspectives.vue?vue&type=style&index=0&id=aedddca8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedddca8",
  null
  
)

export default component.exports